import React from "react";
import Link from "next/link";
import { HiArrowLongRight } from "react-icons/hi2";
import { ArrowRight } from "lucide-react";
// import styles from "./buttons.module.css";

const CLMButtonPrimary = ({
  buttonText,
  buttonUrl,
  icon = null,
  // borderShadow = true,
  newTab = false,
  // bgColor = "bg-violet-500",
  textSize = "text-sm",
  ...props
}) => {
  return (
    <Link
      {...props}
      href={`${buttonUrl}`}
      target={newTab ? "_blank" : "_self"}
      // className={`w-fit flex items-center justify-center gap-2 px-5 py-[12px] text-lg text-white ${bgColor} rounded-md ${"hover:bg-violet-500/90"}`}
      className={`bg-blue-600 text-white px-6 py-3 rounded-md ${textSize} font-medium text-center inline-flex justify-center items-center gap-2`}
      style={{
        background: "linear-gradient(275deg, #c86aff -8.37%, #3164ff)",
      }}
    >
      <span className="">{buttonText}</span>
      {icon && <span className="text-base">{icon}</span>}
    </Link>
  );
};
const CLMButtonPrimary1 = ({ buttonText, icon = null, onClick, ...props }) => {
  return (
    <button onClick={() => onClick && onClick()} {...props}>
      <span
        className={`bg-blue-600 text-white px-6 py-3 rounded-md font-medium text-center flex justify-center items-center gap-2 ${props.className}`}
        style={{
          background: "linear-gradient(275deg, #c86aff -8.37%, #3164ff)",
        }}
      >
        <span className="">{buttonText}</span>
        {icon && <span className="text-base">{icon}</span>}
      </span>
    </button>
  );
};
const CLMLinkPrimaryArrow = ({ buttonText, buttonUrl, newTab = false }) => {
  return (
    <Link
      href={`${buttonUrl}`}
      target={newTab ? "_blank" : "_self"}
      className={`group font-medium text-center flex justify-center items-center gap-2`}
    >
      <span
        style={{
          background: "linear-gradient(275deg, #c86aff -8.37%, #3164ff)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {buttonText}
      </span>
      <span className="w-6 h-6 rounded-full flex justify-center items-center text-white bg-gradient-to-tr from-[#c86aff] to-[#3164ff] transform transition-transform duration-300 group-hover:translate-x-2">
        <ArrowRight size={16} />
      </span>
    </Link>
  );
};

const CLMButtonPrimaryArrow = ({ buttonText, onClick }) => {
  return (
    <button
      className={`group font-medium text-center flex justify-center items-center gap-2`}
      onClick={onClick}
    >
      <span
        style={{
          background: "linear-gradient(275deg, #c86aff -8.37%, #3164ff)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {buttonText}
      </span>
      <span className="w-6 h-6 rounded-full flex justify-center items-center text-white bg-gradient-to-tr from-[#c86aff] to-[#3164ff] transform transition-transform duration-300 group-hover:translate-x-2">
        <ArrowRight size={16} />
      </span>
    </button>
  );
};
const CLMButtonSecondary = ({
  buttonText,
  buttonUrl,
  icon,
  newTab = false,
}) => {
  return (
    <Link
      href={`${buttonUrl}`}
      scroll={false}
      target={newTab ? "_blank" : "_self"}
      className="px-6 py-3 bg-white text-blue-600 rounded-lg"
    >
      <span
        className="bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent text-[18px] font-semibold"
        onClick={(e) => e.stopPropagation()}
      >
        {buttonText}
      </span>
      {/* {icon && (
        <span onClick={(e) => e.stopPropagation()} className="text-2xl">
          {icon}
        </span>
      )} */}
    </Link>
  );
};
const CLMButtonSecondaryBorder = ({
  buttonText,
  buttonUrl,
  icon = null,
  newTab = false,
  ...props
}) => {
  return (
    <Link
      href={`${buttonUrl}`}
      scroll={false}
      target={newTab ? "_blank" : "_self"}
      className={`relative inline-block rounded-lg p-[2px] bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 ${props.className}`}
    >
      <span
        onClick={(e) => e.stopPropagation()}
        className=" px-6 py-2 bg-white rounded-md text-blue-600 flex justify-center items-center gap-2"
      >
        <span className="bg-gradient-to-r from-purple-700 via-indigo-500 to-blue-700 bg-clip-text text-transparent">
          {buttonText}
        </span>
        {icon && (
          <span className="w-6 h-6 rounded-full flex justify-center items-center text-white bg-gradient-to-tr from-[#c86aff] to-[#3164ff] ">
            {icon}
          </span>
        )}
      </span>
    </Link>
  );
};
const CLMSecondaryBorder = ({ buttonText, icon = null, ...props }) => {
  return (
    <button
      {...props}
      className={`relative flex justify-center items-center rounded-lg p-[2px] bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 ${
        props.className || ""
      }`}
    >
      <div className=" px-6 py-2 w-full bg-white rounded-md text-blue-600 flex justify-center items-center gap-2">
        <span className="bg-gradient-to-r from-purple-700 via-indigo-500 to-blue-700 bg-clip-text text-transparent">
          {buttonText}
        </span>
        {icon && (
          <span className="w-6 h-6 rounded-full flex justify-center items-center text-white bg-gradient-to-tr from-[#c86aff] to-[#3164ff] ">
            {icon}
          </span>
        )}
      </div>
    </button>
  );
};
// we will create one more button named CLMButtonAnimation

// const CLMRoundButton = ({
//   buttonText,
//   buttonUrl,
//   icon,
//   newTab = false,
//   fullWidth = true,
//   transparent = true,
// }) => {
//   return (
//     <Link
//       href={`${buttonUrl}`}
//       target={newTab ? "_blank" : "_self"}
//       className={`${
//         fullWidth ? "w-full" : "w-fit"
//       } flex items-center justify-center px-6 py-[12px] ${
//         transparent
//           ? "bg-transparent text-black hover:bg-black hover:text-[#fff]"
//           : "text-[#fff] bg-black"
//       }  text-xl text-gray-900 border border-gray-800 rounded-full transition-all duration-300 ease-in-out`}
//     >
//       <span onClick={(e) => e.stopPropagation()} className="">
//         {buttonText}
//       </span>
//       {icon && (
//         <span onClick={(e) => e.stopPropagation()} className="text-xl">
//           {icon}
//         </span>
//       )}
//     </Link>
//   );
// };

// const CLMRoundButtonDiv = ({
//   buttonText,
//   icon,
//   onclick,
//   fullWidth = true,
//   transparent = true,
// }) => {
//   return (
//     <div
//       onClick={() => {
//         if (onclick) onclick();
//       }}
//       className={`${
//         fullWidth ? "w-full" : "w-fit"
//       } cursor-pointer flex items-center justify-center px-6 py-[12px] ${
//         transparent
//           ? "bg-transparent text-black hover:bg-black hover:text-[#fff]"
//           : "text-[#fff] bg-black"
//       }  text-xl text-gray-900 border border-gray-800 rounded-full transition-all duration-300 ease-in-out`}
//     >
//       <span className="">{buttonText}</span>
//       {icon && <span className="text-xl">{icon}</span>}
//     </div>
//   );
// };

// const CLMButtonSecondaryDiv = ({
//   buttonText,
//   icon,
//   onclick,
//   isFullWidth = true,
//   textClassName,
// }) => {
//   return (
//     <div
//       onClick={() => onclick && onclick()}
//       className={`${
//         isFullWidth ? "w-full" : "w-fit"
//       } cursor-pointer flex items-center justify-center gap-2 px-6 py-[12px] bg-white hover:bg-violet-500 text-lg text-gray-900 hover:text-white border border-gray-600 hover:border-white rounded-md transition-all duration-300 ease-in-out`}
//     >
//       {icon && <span className="text-2xl">{icon}</span>}
//       <span className={`${textClassName}`}>{buttonText}</span>
//     </div>
//   );
// };

// const CLMButtonPrimaryDiv = ({
//   buttonText,
//   onclick,
//   icon = <HiArrowLongRight />,
//   borderShadow = true,
//   bgColor = "bg-violet-500",
// }) => {
//   return (
//     <div
//       onClick={() => {
//         if (onclick) onclick();
//       }}
//       className={`w-fit cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 px-5 py-[12px] text-lg text-white ${bgColor} rounded-md ${"hover:bg-violet-500/90"}`}
//     >
//       <span className="whitespace-nowrap">{buttonText}</span>
//       {icon && <span className="text-2xl">{icon}</span>}
//     </div>
//   );
// };

export {
  CLMButtonPrimary,
  CLMButtonSecondary,
  CLMButtonPrimary1,
  CLMLinkPrimaryArrow,
  CLMButtonPrimaryArrow,
  CLMButtonSecondaryBorder,
  CLMSecondaryBorder,
  // CLMButtonSecondaryDiv,
  // CLMRoundButton,
  // CLMRoundButtonDiv,
  // CLMButtonPrimaryDiv,
};
